var render = function render(){var _vm=this,_c=_vm._self._c;return _c('figure',_vm._b({domProps:{"innerHTML":_vm._s(_vm.contents.content)}},'figure',_vm.contents.attributes,false))
}
var staticRenderFns = []

export { render, staticRenderFns }